import Button from 'components/atoms/Button';
import type { BottomSheetProps } from 'components/molecules/BottomSheet';
import BottomSheet from 'components/molecules/BottomSheet';
import { BUTTON_NAMES } from 'constant/button-names';
import { useConfig } from 'context/app-config';
import React, { useCallback } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { checkApplyPayCompatibility } from 'wrappers/apple_pay';

interface Props extends BottomSheetProps {
  onPaymentSelected?(paymentType: 'card' | 'applePay'): any;
}
const StyledPaymentMethodQuestion = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
`;

const StyledAuthorizationMessage = styled.div`
  color: ${({ theme }) => theme.colors.slateGray500};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.1px;

  ${({ theme }) =>
    theme.components.paymentMethodSheet &&
    `
    padding: ${theme.components.paymentMethodSheet.footNote.padding}px;
    margin: ${theme.components.paymentMethodSheet.footNote.margin};
    margin-bottom: ${theme.components.paymentMethodSheet.footNote.marginBottom}px;
    width: ${theme.components.paymentMethodSheet.footNote.maxWidth};
  `}
`;

const StyledButton = styled(Button)`
  padding: unset;
`;

const StyledAppleButton = styled.div`
  border-radius: 100px;
`;

const SelectPaymentMethodSheet: React.FC<Props> = ({ onPaymentSelected = () => {}, ...props }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const onPaymentModeSelected = useCallback(
    (method: 'card' | 'applePay') => () => {
      onPaymentSelected(method);
    },
    []
  );

  return (
    <BottomSheet title={t('newOrderPage.paymentMethodHeading')} {...props}>
      {config?.modules.checkout.paymentMethod?.paymentMethodQuestion && (
        <StyledPaymentMethodQuestion>{t('newOrderPage.paymentMethodQuestion')}</StyledPaymentMethodQuestion>
      )}
      <Row>
        <Col xs={12} className="mb-3">
          <StyledButton buttonName={BUTTON_NAMES.PAYMENT_OPTION} block size="lg" onClick={onPaymentModeSelected('card')}>
            {t('newOrderPage.paymentOptions')}
          </StyledButton>
        </Col>
        {checkApplyPayCompatibility() && (
          <Col xs={12}>
            <StyledAppleButton className="apple-pay-button apple-pay-button-black" onClick={onPaymentModeSelected('applePay')} aria-hidden="true" />
          </Col>
        )}
        <Col xs={12}>
          {config?.modules.checkout.paymentMethod?.paymentMethodQuestion ? (
            <StyledAuthorizationMessage>{t('newOrderPage.cardWorkingConfirmationMessage')}</StyledAuthorizationMessage>
          ) : (
            <StyledAuthorizationMessage className="h5 font-weight-light mt-18">
              {t('newOrderPage.cardWorkingConfirmationMessage')}
            </StyledAuthorizationMessage>
          )}
        </Col>
      </Row>
    </BottomSheet>
  );
};

export default SelectPaymentMethodSheet;
